import React from 'react';
import classes from './header.module.css';
import {Flex} from "antd";
import BhargaButton from "../../../components/UI/Buttons/BhargaButton";
import SteveBloxButton from "../../../components/UI/Buttons/SteveBloxButton";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import {Link} from "react-router-dom";

const Header = () => {
    return (
        <Flex className={classes.main} align={"center"} justify={"center"}>
            <Flex className={classes.inner_main} align={"center"} justify={"flex-start"} gap={75}>
                <Link to={'/'} className={classes.hover_text} style={{color: "white", fontSize: "1rem", fontWeight: 700}}><IntlMessage id={'homePage.main'}/></Link>
                <Link to={'/monitoring'} className={classes.hover_text} style={{color: "white", fontSize: "1rem", fontWeight: 700}}><IntlMessage id={'homePage.monitoring'}/></Link>
                <Link to={'/about'} className={classes.hover_text} style={{color: "white", fontSize: "1rem", fontWeight: 700}}><IntlMessage id={'homePage.aboutProject'}/></Link>
                <Link to={'/dashboard'} className={classes.hover_text} style={{color: "white", fontSize: "1rem", fontWeight: 700}}><IntlMessage id={'homePage.dashboard'}/></Link>
                {/*<Link className={classes.hover_text} style={{color: "white", fontSize: "1rem", fontWeight: 700}}><IntlMessage id={'homePage.systemTradeEmission'}/></Link>*/}
            </Flex>
        </Flex>
    );
};

export default Header;